import {useState} from 'react';
import styles from 'assets/jss/Report/UserInfoStyle';
import makeStyles from '@mui/styles/makeStyles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Button, Grid} from '@mui/material';
import {Link} from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import {styled} from '@mui/material/styles';
import Loading from './Loading';
import Details from './Details';
import {useReport} from "../../../hooks/useReport";
import {usePatientInfo} from "../../../hooks/usePatient";
import {PRODUCTION_MODE} from "../../../helpers/Functions";
import {detectPathUrl} from "../../../helpers/detectPathUrl";
const useStyles = makeStyles(styles);
// *************** accordion styles *******************
let openAccShadow =
  '6px 8px 10px rgba(0, 0, 0, 0.06), inset -15px 6px 15px rgba(255, 255, 255, 0.78), inset 4px 6px 10px rgba(101, 99, 99, 0.2)';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
  zIndex: '10',
  borderRadius: '25px',
  width: '100%',
  top: '-20px',
  ['@media (max-width:375px)']: {},
  margin: '0 auto',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon sx={{fontSize: '1.3rem', color: '#707070'}} />}
    {...props}
  />
))(({theme}) => ({
  minHeight: '20px !important',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const PatientInfoAccordion = ({patientId}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState('');

  const {data: patientInfo, isLoading} = usePatientInfo(patientId);
  // for show serial number in authentication information accordion
  const {data:serialData} = useReport(patientId);
  const serialNumber = serialData?serialData[14]?.serialNumber:null

  const handleClose = () => setOpen(false);
  const handleToggle = () => setOpen(!open);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    handleToggle();
  };
  const patientFullName = `${patientInfo?.firstName} ${
    patientInfo?.lastName ? patientInfo?.lastName : ''
  }`;

  return (
    <>
      <Backdrop
        sx={{
          zIndex: '10',
          color: '#ffffff',
          background: 'rgba(216, 216, 216, 0.37);',
        }}
        open={open}
        onClick={handleClose}
      />
      <Accordion
        sx={{
          boxShadow: open
            ? openAccShadow
            : '-2px -2px 4px #FFFFFF, 1px 1px 10px rgba(0, 0, 0, 0.1)',
          background: open ? '#F4F4F4' : '#FFFFFF',
        }}
        expanded={open}
        onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls='panel1d-content' id='panel1d-header'>
          {isLoading ? (
            <Loading />
          ) : (
            <span
              className={classes.AccordionHeader}
              style={{
                color: expanded !== 'panel1' ? '#707070 ' : 'var(--purply)',
              }}>
              {patientFullName}
            </span>
          )}
        </AccordionSummary>
        <Details patientInfo={patientInfo} serialNumber={serialNumber} />
        <Grid display='flex' justifyContent='center' item xs={12}>
          <Link to={{pathname:detectPathUrl('app/edit')}} state={{patientId}}>
            <Button className={classes.EditButton}>ویرایش اطلاعات بیمار</Button>
          </Link>
        </Grid>
      </Accordion>
    </>
  );
};

export default PatientInfoAccordion;
